export default __webpack_public_path__ + "static/media/phoneRinging.138511dd.svg";